import React from 'react';

const DownArrow = () => (
    <svg width="8.4" height="5.659" viewBox="0 0 6.4 3.659">
        <path id="Icon_ionic-ios-arrow-down" data-name="Icon ionic-ios-arrow-down" d="M9.389,13.8l2.42-2.422a.455.455,0,0,1,.646,0,.461.461,0,0,1,0,.648L9.713,14.773a.457.457,0,0,1-.631.013L6.321,12.031a.457.457,0,1,1,.646-.648Z" transform="translate(-6.188 -11.246)"/>
    </svg>
);

export default DownArrow;